import axios from 'axios';

const axiosQlikClient = () => {
  const defaultOptions = {
    baseURL: `${process.env.REACT_APP_API_HOST}/api/`,
    headers: {
      'Content-Type': 'application/json',
    },
  };

  // Create instance
  let instance = axios.create(defaultOptions);

  // Set the AUTH token for any request
  instance.interceptors.request.use(
    function (config) {
      // In case of verify cookie API call, Authorization header is already set as Qlick token.
      if (!config.headers.Authorization) {
        config.headers.Authorization = `Bearer ${localStorage.getItem('token')}`;
      }
      config.headers.qlikCookie = localStorage.getItem('qlikCookie');

      return config;
    },
    (error) => Promise.reject(error)
  );

  return instance;
};

export default axiosQlikClient();
